import { useRef, useState } from 'react';

import { useClickAway } from '@crehana/react-hooks';

const useContainerRef = () => {
  const containerRef = useRef(null);

  const [isOpen, setIsOpen] = useState(false);

  useClickAway(containerRef, () => setIsOpen(false));

  return { containerRef, isOpen, setIsOpen };
};

export default useContainerRef;
